// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iEVU","label":"styles_label__3Au2q"};